import {useQuery} from "@tanstack/react-query";
import {Form, FormInstance, Modal, Select, Space, Statistic, Typography} from "antd";
import React, {useState} from "react";
import {TEVService} from "../../tevapi/io";
import {LoadingAnimation} from "../loading-page";
import {CreateCollectionForm, onOkFactory} from "../forms/collections";
import {useNavigate} from "react-router-dom";


interface IMutateSelectionForm {
  selection: number[];
  form: FormInstance;
};


export const MutateSelectionForm: React.FC<IMutateSelectionForm> = (props) => {

  const [method, setMethod] = useState<string | null>(null);
  const methodOptions = [
    {label: "To Sources", value: "to_sources"},
    {label: "To Atlases", value: "to_atlases"},
  ];

  const query = useQuery({
    queryKey: ["item", "selection", method, props.selection],
    queryFn: async (): Promise<number[]> => {
      const response = await TEVService.post(
        "/itemdata/mutate_pks/",
        {
          method: method,
          selection: props.selection,
        }
      );
      props.form.setFieldValue("items", response.data);
      return response.data;
    },
    enabled: method !== null,
    refetchOnWindowFocus: false,
  });

  return (
    <Space direction="vertical">
      <Select
        options={methodOptions}
        value={method}
        onChange={setMethod}
        placeholder="Mutation method"
      />
      {
        query.isLoading || query.data === undefined ?
          <LoadingAnimation /> :
          <Space direction="horizontal">
            <Statistic value={props.selection.length} title="Selected Items" />
            <Statistic value={query.data.length} title="Mutated Items" />
          </Space>
      }
      <CreateCollectionForm form={props.form} />
    </Space>
  );
};


export const MutateSelection: React.FC<{selection: number[]}> = (props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  return (
    <>
      <Typography.Text
        onClick={() => setModalOpen(true)}
        disabled={props.selection.length === 0}
      >
        Mutate Selection
      </Typography.Text>
      <Modal
        open={modalOpen}
        title="Mutate Selection"
        onCancel={() => setModalOpen(false)}
        onOk={onOkFactory(form, navigate, "/collections/", setModalOpen)}
      >
        <MutateSelectionForm selection={props.selection} form={form} />
      </Modal>
    </>
  );
};
